var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsepticConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 300.5,
    y: 232,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 59.6,
    width: 9.6,
    y: 10.2,
    x: 23.3
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    height: 40.6,
    width: 9.6,
    y: 19.6,
    x: 33.2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 9.6,
    width: 23.7,
    y: 10.2,
    x: 32.9
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "#FFFFFF",
    height: 9.6,
    width: 23.7,
    y: 60.2,
    x: 32.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsepticConnector);
export default __webpack_public_path__ + "static/media/asepticConnector.0934e58442cd1e9e3440a392781d3012.svg";
export { ForwardRef as ReactComponent };